import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { AdvancingSessionCard } from "advancing/components/AdvancingSessionCard";
import { joinWithMaxLength } from "shared/utils/stringutils";

const MAX_VISIBLE_RECIPIENTS = 2;

interface Props {
  item: server.dto.AdvancingSessionForListForInternalUser
}

const AdvancingRowCard = (props: Props) => {
  const { advancingSession, participants } = props.item;
  const recipients = joinWithMaxLength(participants, ", ", MAX_VISIBLE_RECIPIENTS);

  return <AdvancingSessionCard
    session={advancingSession}
    side="approve"
    href={routes.advancingApprove_Detail(advancingSession.advancingSessionId).absolute}
    footer={<>
      {advancingSession.ownerUser.fullName} → {recipients || <span className="s1_red">There are no participants</span>}
    </>}
  />;
};

export default AdvancingRowCard;
